import Skeleton from "react-loading-skeleton";

export const LoadingSkeleton = () => (
  <div className="card mb-4 card-transaction skeleton">
    <div className="card-body">
      <div
        className="card-title d-flex justify-content-between align-items-center"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="invoice-label">
          <Skeleton width={150} />
        </div>
        <div>
          <Skeleton width={100} />
        </div>
      </div>
    </div>
    <div className="card-text">
      <dl className="d-flex">
        <dt className="col-4 col-md-3">
          <Skeleton width={150} />
        </dt>
        <dd>
          <Skeleton width={200} />
        </dd>
      </dl>
      <dl className="d-flex">
        <dt className="col-4 col-md-3">
          <Skeleton width={150} />
        </dt>
        <dd>
          {" "}
          <Skeleton width={400} />
        </dd>
      </dl>
      <dl className="d-flex">
        <dt className="col-4 col-md-3">
          <Skeleton width={150} />
        </dt>
        <dd>
          <Skeleton width={300} />
        </dd>
      </dl>
    </div>
    <div className="card-footer d-flex justify-content-end align-items-center gap-2">
      <Skeleton width={70} height={25} />
      <Skeleton width={70} height={25} />
    </div>
  </div>
);
